/* src/app/shared/components/loading-overlay/loading-overlay.component.scss */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}
.loading-overlay.active {
  opacity: 1;
  pointer-events: all;
}
.loading-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(0.5px);
  backdrop-filter: blur(0.5px);
  animation: fadeIn 0.3s ease-in-out;
}
.loading-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
  min-width: 200px;
}
.loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin-bottom: 1rem;
}
.spinner-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-radius: 50%;
  animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
}
.spinner-ring:nth-child(1) {
  border-top-color: #2563eb;
  animation-delay: 0s;
}
.spinner-ring:nth-child(2) {
  border-right-color: #3b82f6;
  animation-delay: 0.1s;
}
.spinner-ring:nth-child(3) {
  border-bottom-color: #64748b;
  animation-delay: 0.2s;
}
.spinner-ring:nth-child(4) {
  border-left-color: #94a3b8;
  animation-delay: 0.3s;
}
.loading-text {
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.5rem;
  text-align: center;
}
.loading-count {
  font-size: 0.9rem;
  color: #666;
  text-align: center;
  font-style: italic;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
    opacity: 1;
    scale: 1;
  }
  50% {
    opacity: 0.8;
    scale: 1.1;
  }
  100% {
    transform: rotate(360deg);
    opacity: 1;
    scale: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
    scale: 0.9;
  }
  to {
    transform: translateY(0);
    opacity: 1;
    scale: 1;
  }
}
/*# sourceMappingURL=loading-overlay.component-VK75V7OW.css.map */
